import React, { useState, useEffect } from 'react'
import Logo from '../../assets/logo.png';
import Swal from 'sweetalert2'
import withReactContent from 'sweetalert2-react-content'
import FormComponent from '../../components/Form/Form';
import { getDrugstores, deleteDrugstore } from '../../services/farmacias';
import formatDate from '../../helpers/formatDate';

import './styles.scss'

const MySwal = withReactContent(Swal)

export default function Manager() {

  const [farmacias, setFarmacias ] = useState('');
  const [title, setTitle] = useState('');
  const [selectedStore, setSelectedStore] = useState('');

  useEffect(() => {
    getFarmacias()  
  },[]) 

  const getFarmacias = async () => { 
    const response = await getDrugstores();
    console.log(response)
    setFarmacias(response)
  }

  const [ formOpen, setFormOpen ] = useState(false);

  const handleFormOpen = () => { 
    setTitle('Cadastrar Farmácia')
    setSelectedStore(null)
    setFormOpen(true); 
  }

  const handleFormClose = () => {
    setFormOpen(false);
  }

  const handleEdit = (store) => {

    setSelectedStore(store)
    setFormOpen(true);
  
    setTitle('Editar Farmácia');
  }

  const handleDelete = (id) => { 
    MySwal.fire({
      title: 'Tem certeza que deseja excluir ?',
      text: "Você não poderá reverter isso!",
      icon: 'warning',
      showCancelButton: true,
      confirmButtonColor: '#3085d6',
      cancelButtonColor: '#d33',
      confirmButtonText: 'Sim, excluir!',
      cancelButtonText: 'Cancelar',
    }).then((result) => {
      if (result.isConfirmed) {

        deleteDrugstore(id);
        getFarmacias()

        MySwal.fire(
          'Excluido!',
          'Cadastro excluido com sucesso.',
          'success'
        )
      }
    })
  }

  return (
    <>
    { formOpen ? ( <FormComponent selectedStore={selectedStore} reset={() => getFarmacias()} close={handleFormClose} title={title ? title : 'Cadastrar'} />) : null }

      { farmacias ? (
        <>
          <div className='Header'>
          <h1>Farmácias cadastradas</h1>
          <img src={Logo} alt="Logo" />
        </div>
        <div className='panel_header'>
            <span>Nome</span>
            <span>Data</span>
            <span>Ações</span>
          </div> 
        
        <div className='panel'>
          <div className='panel_body'>
          { farmacias.map((item) => (
              <div className='item'>
              <div className='panel_item'>
                <span>{item.name}</span>
              </div>
              <div className='panel_item'>
                <span>{`${formatDate(item.horario.inicio, item.horario.inicio)} - ${formatDate(item.horario.final, item.horario.inicio)}`}</span>
              </div>
              <div className='panel_item'>
              <button  onClick={() => handleEdit(item)} className='edit'>Editar</button>
                <button onClick={() => handleDelete(item._id)} className='delete'>Excluir</button>
              </div>
              </div>
          )) } 
         </div>
        </div>
        </>
      ) : null }
    
      <button onClick={() => handleFormOpen()} className='cadastro'>Cadastar nova</button>
    </>
  )
}
